import type { JSX, PropsWithChildren } from 'react';

import { useLoadQueue } from './useLoadQueue';

export function ShortUrlsCacheQueueProvider({ children }: PropsWithChildren<EmptyProps>): JSX.Element {
	useLoadQueue();

	return <>{children}</>;
}
